export const NAV_LINKS = [
  { key: "problem", id: "problem", label: "Problem" },
  { key: "solution", id: "value", label: "Solution" },
  { key: "roi-calculator", id: "savings-calculator", label: "ROI calculator" },
  { key: "how-it-works", id: "how-it-works", label: "How it works" },
  { key: "who-we-serve", id: "who-its-for", label: "Who we serve" },
];

export const NAV_IDS = NAV_LINKS.map((l) => l.id);

export const FOOTER_LINKS = [
  { id: "problem", label: "Problem" },
  { id: "value", label: "Features" },
  { id: "how-it-works", label: "How it works" },
  { id: "who-its-for", label: "Who we serve" },
  { id: "faq", label: "FAQ" },
  { id: "demo", label: "Book a demo" },
];

export const PAIN_HERO = { value: "$250 million", caption: "lost per year" };

export const PAIN_STATS = [
  { value: "30–40%", caption: "rejected on first review" },
  { value: "$805", caption: "per rejection" },
  { value: "3 weeks", caption: "delay per rejection" },
];

export const VALUE_HERO = { from: "2 weeks", to: "2 hours", caption: "using Condoor" };

export const VALUE_STATS = [
  { value: "80%", caption: "less prep time" },
  { value: "<5%", caption: "rejection rate" },
  { value: "$2,500", caption: "saved per submittal" },
];

export const STEPS = [
  { title: "Upload specs", body: "Drop in specs, drawings and door schedule." },
  { title: "Create submittal", body: "Condoor builds and checks every opening." },
  { title: "Reviewed by architect", body: "Approved on first review." },
];

export const PERSONAS = [
  { tag: "GC", title: "General contractors", body: "Stop losing weeks to rejected door packages." },
  { tag: "Supplier", title: "Door hardware distributors", body: "Prep hardware submittals in a fraction of the time." },
  { tag: "AHC", title: "Hardware consultants (AHCs)", body: "Check every opening with one repeatable process." },
];

export const FAQS = [
  { q: "What does Condoor check?", a: "Each opening's hardware against the spec, door schedule and code — flagged before it reaches the architect." },
  { q: "Who is it for?", a: "General contractors, door hardware distributors and hardware consultants (AHCs)." },
  { q: "What do I need to start?", a: "Your project spec and door hardware schedule." },
  { q: "Does it replace the architect's review?", a: "No. It makes your submittal cleaner, so review goes faster. Approval stays with the reviewer." },
  { q: "Where do the numbers come from?", a: "Industry figures: BuildSync, Construction Review Online, Helonic. Condoor figures are estimates and vary by project." },
];

export const ROLES = ["General contractor", "Door hardware distributor / supplier", "Hardware consultant (AHC)", "Architect", "Other"];

export const SOURCES_NOTE = "Sources: BuildSync, Construction Review Online, Helonic.";
